<template>
  <v-dialog persistent v-model="value" max-width="700px" scrollable>
    <v-card>
      <v-toolbar dark color="gradiente">
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Audiencia</v-toolbar-title>
      </v-toolbar>
      <v-container fluid style="max-height: 93vh;" class="scrollDesign">
        <v-flex xs12>
          <v-layout row wrap justify-space-around scrollDesign style="max-height: 320px;">
            <v-flex xs12 sm6 v-if="payment.metadata.institutional">
              <v-alert
                style="border-radius:33px;"
                :value="true"
                type="info"
                color="gradiente"
              >Toda la institución será notificada</v-alert>
            </v-flex>
            <v-flex xs12 sm4 v-if="payment.levels && payment.levels.length > 0">
              <v-list subheader two-line>
                <v-subheader key="subheader">Niveles</v-subheader>
                <v-slide-y-transition class="two-line subheader" group>
                  <v-list-tile
                    avatar
                    class="pa-0 mb-3 elevation-1 grey lighten-5 list-group-item item"
                    style="border-radius: 5px;"
                    v-for="element in payment.levels"
                    :key="element.id"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="element.typeLevel"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-slide-y-transition>
              </v-list>
            </v-flex>
            <v-flex xs12 sm4 v-if="payment.groups && payment.groups.length > 0">
              <v-list subheader two-line>
                <v-subheader key="subheader">Grupos</v-subheader>
                <v-slide-y-transition class="two-line subheader" group>
                  <v-list-tile
                    avatar
                    class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                    style="border-radius: 5px;"
                    v-for="element in payment.groups"
                    :key="element.id"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="element.grade + ' ' + element.group"></v-list-tile-title>
                      <v-list-tile-sub-title v-text="element.level.typeLevel"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-slide-y-transition>
              </v-list>
            </v-flex>

            <v-flex xs12 sm4 v-if="payment.subgroupIds && payment.subgroupIds.length > 0">
              <v-list subheader two-line>
                <v-subheader key="subheader">Subgrupos</v-subheader>
                <v-slide-y-transition class="two-line subheader" group>
                  <v-list-tile
                    avatar
                    class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                    style="border-radius: 5px;"
                    v-for="element in payment.subgroupIds"
                    :key="element.id"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="element.name"></v-list-tile-title>
								      <v-list-tile-sub-title v-text="element.level.typeLevel"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-slide-y-transition>
              </v-list>
            </v-flex>

            <v-flex xs12 sm4 v-if="payment.webRoleIds && payment.webRoleIds.length > 0">
              <v-list subheader two-line>
                <v-subheader key="subheader">Colaboradores</v-subheader>
                <v-slide-y-transition class="two-line subheader" group>
                  <v-list-tile
                    avatar
                    class="pa-0 mb-3 elevation-1 grey lighten-5 list-group-item item"
                    style="border-radius: 5px;"
                    v-for="element in payment.webRoleIds"
                    :key="element.id"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="element.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-slide-y-transition>
              </v-list>
            </v-flex>

            <v-flex xs12 sm4 v-if="payment.students && payment.students.length > 0">
              <v-list subheader two-line>
                <v-subheader key="subheader">Alumnos</v-subheader>
                <v-slide-y-transition class="two-line subheader" group>
                  <v-list-tile
                    avatar
                    class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                    style="border-radius: 5px;"
                    v-for="element in payment.students"
                    :key="element.id"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="require('@/assets/panel/home/SKLB-Alumnos.png')"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="element.firstName + ' ' + element.lastName"></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-text="element.level.typeLevel + ' ' + element.gg.grade + ' ' + element.gg.group"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-slide-y-transition>
              </v-list>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    props: ["value", "payment", "institutional"],
    methods:{
        close() {
            this.$emit("onClosed");
        }
    }
}
</script>